import React from 'react';
import Panel from '../components/Panel';
import {Collapse} from 'reactstrap';
import './FaqList.scss';
import store, {actions} from '../store';
import helpers from '../lib/helpers';
import _ from 'lodash';

export default class FaqList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      activeQA: 0,
    };
  }

  async componentDidMount() {
    let faqs = await store.dispatch(actions.faqs.fetchAll());
    let activeTab = null;
    faqs = _.sortBy(faqs,['faqOrder','createdAt']);
    if (faqs.length > 0) {
      activeTab = faqs[0].faqId;
    }
    this.setState({
      initializing: false,
      faqs,
      activeTab,
    });
  }

  deriveClass(tab) {
    return 'btn btn-outline-dark btn-block btn-toggle' +
        (this.state.activeTab === tab ? ' active' : '');
  }

  switchTab(tab) {
    this.setState({activeTab: tab, activeQA: 0});
  }

  switchQA(index,e) {
    e.preventDefault();
    this.setState({
      activeQA: index,
    });
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : (
        <Panel title="FAQ" className="Faq">
          <div className="row">
            <div className="col-md-4">
              <ul className="nav flex-column">
                {
                  this.state.faqs.map((faq) => {
                    return (
                        <li className="nav-item">
                          <button
                              className={this.deriveClass(faq.faqId)}
                              onClick={this.switchTab.bind(this, faq.faqId)}
                          >
                            {faq.faqName}
                          </button>
                        </li>
                    );
                  })
                }
              </ul>
              <div style={{paddingTop: '40px'}}>
                <img src="/img/accordion-img.png"/>
              </div>
            </div>
            <div className="col-md-8">
              {
                this.state.faqs.map((faq) => {
                  return (
                      <Collapse isOpen={this.state.activeTab === faq.faqId}
                                className='accordion-content'>
                        {
                          (faq.faqQA || []).map((qa, index) => {
                            return (<div className="qa-content" key={"qa_" + index}>
                              <a href='#'
                                 className="text-primary font-weight-bold qa-question"
                                 onClick={this.switchQA.bind(this, index)}
                              >{qa.q}</a>
                              <Collapse isOpen={this.state.activeQA === index} className="qa-answer">
                                <p>
                                  {(qa.a || '').split('\n').map((chunk) => {
                                    return [
                                      chunk,
                                      <br/>,
                                    ];
                                  })}
                                </p>
                              </Collapse>
                            </div>);
                          })
                        }
                      </Collapse>
                  );
                })
              }
            </div>
          </div>
        </Panel>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/FaqList.js